import React from 'react';
import { useContext } from 'react';
import { Navigate, } from 'react-router-dom';
import AuthContext from '../AppContext/AuthContext';
import CorporateFacilityGate from './CorporateFacilityGate';

const PrivateRoute = ({ children }) => {
    const { IsAuthenticated, IsAuthChecking } = useContext(AuthContext);

    if (IsAuthChecking) {
        return null;
    }


    if (!IsAuthenticated) {
        return <Navigate to={`/`} />;
    }

    return (
        <CorporateFacilityGate>
            {children}
        </CorporateFacilityGate>
    );
};

export default PrivateRoute;
